import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { getCoApplicantPrequalifyingFields } from './details-form-coapplicant-prequalifying';
import { getCoApplicantPersonalFields } from './details-form-coapplicant-personal';
import { getCoApplicantBankingFields } from './details-form-coapplicant-banking';
import { getCoApplicantEmploymentFields } from './details-form-coapplicant-employment';
import { TabsAction } from '../../shared/formly/types/tabs.type';

/**
 * SECTION 4: CO-APPLICANT INFORMATION
 */
export function getCoApplicantFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  const removeCoApplicantAction: TabsAction = {
    label: 'Remove Co-Applicant',
    icon: 'person_remove',
    color: 'warn',
    onClick: () => options.onRemoveCoApplicantClick(),
  };
  const restoreCoApplicantAction: TabsAction = {
    label: 'Restore Co-Applicant',
    icon: 'person_add',
    color: 'primary',
    onClick: () => options.onRestoreCoApplicantClick(),
  };
  const coApplicantHistoryAction: TabsAction = {
    label: 'History',
    icon: 'history',
    color: 'primary',
    onClick: () => options.onCoApplicantHistoryClick(),
  };

  return [
    {
      type: 'tabs',
      expressions: {
        // Offer removal once a co-applicant exists (first name saved, not just typed). Without one,
        // removed co-applicants (RemovedCoApplicantHistory) can be restored, or a new one entered.
        // History sits beside them once the application has any removals.
        // Each action is hidden when its COAPPLICANT_REMOVE_RESTORE flag is off (_can* is false).
        'props.actions': (field: FormlyFieldConfig) => {
          const actions: TabsAction[] = [];
          if (field.model?._hasCoApplicantHistory === true && field.model?._canShowCoApplicantHistory !== false) {
            actions.push(coApplicantHistoryAction);
          }
          if (field.model?._hasSavedCoApplicant === true) {
            if (field.model?._canRemoveCoApplicant !== false) {
              actions.push(removeCoApplicantAction);
            }
          } else if (field.model?._hasRemovedCoApplicant === true && field.model?._canRestoreCoApplicant !== false) {
            actions.push(restoreCoApplicantAction);
          }
          return actions;
        },
      },
      fieldGroup: [
        {
          props: {
            label: 'Pre-qualifying',
          },
          fieldGroup: getCoApplicantPrequalifyingFields(options),
        },
        {
          props: {
            label: 'Personal',
          },
          fieldGroup: getCoApplicantPersonalFields(options),
        },
        {
          props: {
            label: 'Banking',
          },
          fieldGroup: getCoApplicantBankingFields(options),
        },
        {
          props: {
            label: 'Employment',
          },
          fieldGroup: getCoApplicantEmploymentFields(options),
        },
      ]
    },
  ];
}